import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStore } from '@lib/user/data-access';

export const authGuard: CanActivateFn = (): boolean => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
